module.exports = __webpack_public_path__ + "img/facebook.869ed393.webp";